import styled from 'styled-components';
import { BouSpinner, SpinnerProps } from './bou-spinner';

interface Props extends SpinnerProps {
  containerHeight?: string;
  containerWidth?: string;
  className?: string;
}

export const CenteredSpinner = ({ className, ...props }: Props) => {
  return (
    <Root className={className} {...props}>
      <BouSpinner {...props} />
    </Root>
  );
};

const Root = styled.div<Props>`
  height: ${props => props.containerHeight || '100%'};
  width: ${props => props.containerWidth || '100%'};
  display: flex;
  align-items: center;
  justify-content: center;
`;
